import React from 'react'

const CartIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="icon--cart"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.24841 6.01302L2.02763 5.42366L14.6893 7.42542L15.2606 8.12958L14.6902 19.3706L13.874 20L0.534374 17.2072L0 16.4631L1.24841 6.01302ZM2.51152 6.87324L1.42036 16.0071L13.3759 18.5101L13.8752 8.6698L2.51152 6.87324Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.77637 5.0565L17.1307 6.68032L17.7114 7.24213L19.3203 16.9818L18.9371 17.7073L14.1103 19.9512L13.6837 19.9996L0.656311 17.2349L0.937865 15.9082L13.7438 18.6259L17.8983 16.6946L16.4553 7.95944L4.59963 6.40118L4.77637 5.0565Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64833 4.98907L4.8581 4.98607L17.1159 6.72608L17.2328 8.04154L15.1658 8.72245L14.8492 8.7484L2.11312 6.76335L2.10309 5.42493L4.64833 4.98907Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46295 1.39843C7.60023 1.10641 6.13496 2.35896 6.13496 4.19928V6.10418H4.77872V4.19928C4.77872 1.50875 7.00486 -0.359728 9.673 0.0585557C12.2625 0.464503 14.3572 2.88001 14.3572 5.48536V7.39025H13.001V5.48536C13.001 3.55984 11.4044 1.70278 9.46295 1.39843Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default CartIcon
